export default {
  Basic: 'BMP.Partner.User',
  Manager: 'BMP.Partner.Manager.User',
  Import: 'BMP.Partner.Import.User',
  Report: 'BMP.Partner.Report.User',
  Analista: 'BMP.Partner.Analista.User',
  Gestor: 'BMP.Partner.Gestor.User',
  Master: 'BMP.Partner.Master.User',
  Vendedor: 'BMP.Partner.Vendedor.User',
};